import { motion } from 'framer-motion';
import { Text } from '@chakra-ui/react';

const MotionText = motion(Text);

export default MotionText;
